<template>
  <nav
    class="roboto grid gap-20 items-center bg-skin-secondary w-full h-14"
    :class="[
      {
        'grid-cols-nav_module': !SHOWSEARCHCART,
        'grid-cols-navmobile': SHOWSEARCHCART,
        'lg:grid-cols-nav': SHOWSEARCHCART,
      },
    ]"
  >
    <img
      @click="$router.push({ name: 'v2-misCursos' })"
      :src="logo"
      alt=""
      class="w-24 object-center object-contain cursor-pointer lg:h-8 lg:ml-14 h-3.5"
    />

    <Carrito
      v-if="SHOWSEARCHCART"
      @click="$router.push({ name: 'v2-cart-buy' })"
      class="cursor-pointer hidden lg:block"
    />

    <Searchbar v-if="SHOWSEARCHCART" />

    <ProgressModule v-else />

    <section class="flex justify-end pr-4 lg:hidden">
      <BurgerMenu @click="openmodal" />
    </section>

    <UserProfile @click="openmodal" class="hidden lg:flex cursor-pointer" />
  </nav>
</template>

<script>
import Searchbar from "./Searchbar.vue";
import UserProfile from "./UserProfile.vue";
import BurgerMenu from "./BurgerMenu.vue";
import ProgressModule from "./ProgressModule.vue";
import { mapGetters } from "vuex";
import Carrito from "./Carrito.vue";
export default {
  components: {
    UserProfile,
    Searchbar,
    BurgerMenu,
    Carrito,
    ProgressModule,
  },
  props: {
    logo: {
      type: String,
      required: true,
    },
  },
  created() {
    setTimeout(() => {
      window.addEventListener("click", (e) => {
        if (!this.$el.contains(e.target) && this.OPENMODAL == true) {
          this.$store.commit("openmodal", false);
        }
      });
    }, 100);
  },
  computed: {
    ...mapGetters(["OPENMODAL", "SHOWSEARCHCART"]),
  },
  methods: {
    openmodal() {
      this.$store.commit("openmodal", true);
    },
  },
};
</script>

<style></style>
